<template>
    <div class="contenido">
        <h3 class="titulo">Area de administración</h3>

        <b-row>
            <b-col cols="4"></b-col>
            <b-col cols="4 mb-5">
                <b-card
                    header="Ingreso de administradores"
                    header-tag="header"
                    footer-tag="footer"
                    >

                    <b-form>
                        <b-form-input class="mb-2" placeholder="Usuario"></b-form-input>
                        <b-form-input type="password" class="mb-2" placeholder="Constraseña"></b-form-input>
                        
                        <b-button variant="outline-success" class="form-control"><b-icon-door-open></b-icon-door-open> Ingresar</b-button>
                    </b-form>
                </b-card>
            </b-col>
            <b-col cols="4"></b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    name: 'adminLogin',
    props: {
        
    },
    data() {
        return {
            
        }
    },
    components: {
        
    },
    methods: {
        
    }
}
</script>

<style scoped>
.contenido{
    min-height: 500px;
}

.titulo {
    padding-top: 50px;
    padding-bottom: 10px;
    text-align: center;
}
</style>